var map = {
	"./de.json": [
		16494,
		16494
	],
	"./en.json": [
		59748,
		59748
	],
	"./es.json": [
		60124,
		60124
	],
	"./eu.json": [
		60968,
		60968
	],
	"./fr.json": [
		43851,
		43851
	],
	"./it.json": [
		45361,
		45361
	],
	"./ja.json": [
		84328,
		84328
	],
	"./nl.json": [
		5706,
		5706
	],
	"./pt.json": [
		82275,
		82275
	],
	"./pt_BR.json": [
		14943,
		14943
	],
	"./ro.json": [
		51640,
		51640
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 71539;
module.exports = webpackAsyncContext;